/** The container must contain this class to spread inner styling to angle picker component */
export const ANGLE_PICKER_CLASSNAME = 'controls-wrapper';